/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: AppRouter.js
 *  @description: Этот файл является частью клиентской стороны проекта. Относится к части, которая содержит компоненты - части страниц, допускающие многократное использование в разных частях. Установки для навигации по страницам приложения.
 *	@author: Горбас Александр Петрович
*/
import { observer } from 'mobx-react-lite';
import { Routes, Route } from 'react-router-dom'
import { publicRoutes } from '../routes';

const AppRouter = observer( () => {
    return (
        <Routes>
            {publicRoutes.map( r => <Route key={r.path} path={r.path} element={<r.Component />} /> )}
        </Routes>
    );
});

export default AppRouter;
